const styles = {
    // Add your global styles
    global: {
        body: {},
        p: {
            fontWeight: 400,
        },
        span: {
            fontWeight: 400,
        },
    },
};

export default styles;
